import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { validationRules } from "@/ValidationRules";
import { inject, ref } from "vue";
import { useRouter } from "vue-router";
import { LoginServiceSymbol } from "@/InjectionSymbols";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoginView',
    setup(__props) {
        const loginService = inject(LoginServiceSymbol);
        const router = useRouter();
        let username = ref("");
        let password = ref("");
        let form = ref(null);
        function login() {
            form.value.resetValidation();
            form.value.validate().then((result) => {
                if (result.valid) {
                    loginService.login(username.value, password.value)
                        .then(() => {
                        router.push("/admin/dashboard");
                    });
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Login Page", -1)),
                _createVNode(_component_v_container, { class: "v-col-md-2" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_form, {
                            ref_key: "form",
                            ref: form
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _unref(username),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(username) ? (username).value = $event : username = $event)),
                                    rules: [_unref(validationRules).required, _unref(validationRules).email],
                                    label: "Username",
                                    name: "username"
                                }, null, 8, ["modelValue", "rules"]),
                                _createVNode(_component_v_text_field, {
                                    modelValue: _unref(password),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(password) ? (password).value = $event : password = $event)),
                                    rules: [_unref(validationRules).required],
                                    label: "Password",
                                    type: 'password',
                                    name: "password"
                                }, null, 8, ["modelValue", "rules"]),
                                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                _createVNode(_component_v_btn, { onClick: login }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode("Login")
                                    ])),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 512)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
